export default __webpack_public_path__ + "static/media/bc.45700fba.jpg";